// extracted by mini-css-extract-plugin
export var section = "_32-1";
export var topNav = "_32-0";